export default "__VITE_ASSET__e3034adb__"